import { render } from "./KBScreen.vue?vue&type=template&id=293c4efb&scoped=true"
import script from "./KBScreen.vue?vue&type=script&lang=js"
export * from "./KBScreen.vue?vue&type=script&lang=js"

import "./KBScreen.vue?vue&type=style&index=0&id=293c4efb&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293c4efb"]])

export default __exports__